import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Line } from "react-chartjs-2";
import Moment from "moment";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  // responsive: true,
  maintainAspectRatio: false,
  tooltips: {
    callbacks: {
      label: function (tooltipItems, data) {
        return "$" + tooltipItems.y.toString();
      },
    },
  },
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    legend: {
      position: "top",
      align: "end",
      labels: {
        boxWidth: 10,
        boxHeight: 4,
        textAlign: "center",
        color: "#07F2C7",
      },
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: true,
        drawBorder: true, // Display X axis border
        color: "rgba(255, 255, 255, 0.1)",
      },
    },
    y: {
      grid: {
        display: true,
        drawBorder: true, // Display Y axis border
        color: "rgba(255, 255, 255, 0.1)",
      },
      title: {
        display: true,
        text: "Balance",
      },
    },
  },
};
const divStyle = {
  heading: "ext-xl text-lg font-bold leading-4 text-[#333333] ",
};
const PortfolioPlot = ({ userBalanceSheet }) => {
  const balanceData = userBalanceSheet;

  const balance = "balance";
  const date = "date";

  const data =
    balanceData && balanceData.map((item) => [item[date], item[balance]]);
  data.unshift(["date", "Balance"]);

  const DateLable = (data) => {
    let n = data.length;
    let m = 3;
    let Date = [];
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < m; j++) {
        if (i > 0 && j === 0) {
          const one = Moment(data[i][j], "YYYY-MM-DD HH:mm:ss A").format(
            "DD MMM YY"
          );
          Date.push(one);
        }
      }
    }
    return Date;
  };

  const sycrioData = (data) => {
    let n = data.length;
    let m = 3;
    let syp = [];
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < m; j++) {
        if (i > 0 && j === 1) {
          syp.push(data[i][j]);
        }
      }
    }
    return syp;
  };

  const data1 = {
    labels: DateLable(data),
    datasets: [
      {
        label: "  Balance  ",
        data: sycrioData(data),
        borderColor: "#07F2C7",
        backgroundColor: "#07F2C7",
        tension: 0.3,
        borderWidth: 3,
        radius: 0,
        fill: true,
      },
    ],
  };

  return (
    <section className="mx-auto" style={{ height: "100%" }}>
      <section className={`flex justify-between mx-3`}>
        <div className={`d-flex ${divStyle.heading}`}>
          <a
            data-for="main"
            data-tip="Sypto’s vs bitcoin Cumulative performance chart"
            data-iscapture="true"
          >
            <AiOutlineInfoCircle style={{ marginLeft: 5 }} />
          </a>
        </div>
      </section>
      <section className="m-2">
        {data === "undefined" && (
          <div
            className="d-flex  justify-content-center align-items-center"
            style={{ height: "10vh" }}
          >
            <div
              style={{ fontSize: "30px" }}
              className="d-block fw-bold text-center color-black"
            ></div>
          </div>
        )}
        <div style={{ position: "relative", height: "42vh", width: "100%" }}>
          <Line data={data1} options={options} />
        </div>
      </section>
    </section>
  );
};

export default PortfolioPlot;
